import { shared } from '../../config';

export const BASE = appEnvVars => {
  let configSource = appEnvVars ? appEnvVars : shared;

  let apiHttpScheme = configSource.API_HTTP_SCHEME;
  let baseURL = configSource.API_BASE_URL;

  return `${apiHttpScheme}://${baseURL}`;
};

export const SESSION_KEY = '/api/auth/session/';
export const LOADING_STATUS = 'loading';
export const AUTHENTICATED_STATUS = 'authenticated';
export const UNAUTHENTICATED_STATUS = 'unauthenticated';
